import {getRandomFutureDate} from "@utils/random-funture-date";

export const CarInsuranceQuoteTestData = {
   // Step 0
   discoveryType: 'Existing Customer',
   referrersName: 'John Doe',
   contactOptions: ['email', 'phone'],
   discountCode: 'SAVE10',
   
   // Step 1
   title: 'Mr',
   firstName: 'Alex',
   lastName: 'Johnson',
   birthDate: '1990-05-20',
   
   houseNumber: '42',
   addressLine1: 'Baker Street',
   addressLine2: 'Apt 5B',
   
   postCode: 'NW1 6XE',
   maritalStatus: 'Single',
   employmentStatus: 'Employed',
   
   isHomeOwner: 'Yes',
   hasChildrenUnder16: 'No',
   numChildrenUnder16: '0',
   
   contactEmail: 'alex.johnson@example.com',
   contactPhone: '07123456789',
   
   mainOccupation: 'Software Engineer',
   occupationIndustry: 'Technology',
   
   // Step 2
   drivingLicenseType: 'Provisional UK',
   provideDrivingLicenseNumber: 'Yes',
   britishDrivingLicenseNumber: 'SMITH901234AB9CD',
   drivingLicenseDuration: '1 year',
   drivingLicenseDate: '2009-08-15',
   dvlaMedicalConditions: 'DVLA unaware',
   additionalDrivingQualifications: 'Pass Plus',
   additionalDrivingQualificationDate: '2010-03-10',
   isBornInUk: 'Yes',
   lastDateBecameUKResident: '2000-01-01',
   hasNonMotoringCriminalConvictions: 'No',
   nonMotoringCriminalConvictionsDetails: '',
   otherCarUsage: 'Business',
   
   hasAccidentClaimsInLast5Years: 'Yes',
   motorAccidentsList: [
      {
         date: '2022-06-01',
         type: 'Accident',
         partyAtFault: 'Both parties',
         claimCost: '1200',
         wasAccidentSettled : 'No'
      }
   ],
   motorConvictionsList: [
      {
         code: 'SP30',
         date: '2021-04-15',
         points: '3',
         fines: 220,
         banLengthInMonths: 3,
         wasDriverBreathalysed: 'Yes',
         wasOffenceAccidentRelated: 'No'
      }
   ],
   hasMotoringConvictionsInLast5Years: 'Yes',
   
   // Step 3 - Car info
   isCarRegistrationNumKnown: 'Yes',
   
   carRegistrationNumber: 'AB12CDE',
   carMakeAndModel: 'Ford Focus',
   carEstimatedValue: '6500',
   
   manufacturerName: 'Ford',
   manufacturerModel: 'Focus',
   carRegistrationYear: '2018',
   carAlarmsOrImmobiliser: 'Factory fitted alarm',
   carSeatNumber: '5',
   carDoorNumber: '5',
   carEngineSize: '1499',
   carTransmissionType: 'Manual',
   
   hasModifications: 'No',
   modificationType: '',
   modificationDetails: '',
   
   wasCarImported: 'No',
   
   carPurchased: 'Yes',
   carPurchaseDate: '2023-05-20',
   
   registeredKeeper: 'Policyholder',
   legalOwner: 'Policyholder',
   isTheCarOnFinance: 'No',
   carImpoundedWithPolice: 'No',
   
   // Car usage
   carParkingAtDay: 'At my home',
   carParkingAtNight: 'Private Garage',
   isCarKeptOnSameAddress: 'Yes',
   carKeeperAddress: '',
   
   wasInsuranceDeclinedBefore: 'No',
   insurerName: 'Aviva',
   
   carUsageType: 'Social, domestic and pleasure + commuting',
   carUsageTypes: ['SDP', 'Commuting'],
   estimatedAnnualMileage: 'Up to 8000',
   
   insuranceCoverageType: 'Comprehensive',
   noClaimsDiscount: '5 years',
   
   voluntaryExcessAmounts: 'None',
   
   insurancePaymentType: 'Monthly',
   
   currentOrPreviousInsurerName: 'Direct Line',
   renewalPriceOfPreviousInsurer: '850',
   insuranceCoverageStartDate: getRandomFutureDate({months: 6}),
   
   // Step 4
   shouldAddAdditionalDrivers: 'Yes',
   
   additionalDrivers: [
      {
         title: 'Mrs',
         firstName: 'Taylor',
         lastName: 'Johnson',
         relationship: 'Spouse',
         birthDate: '1992-02-14',
         licenseType : 'Full UK Manual',
         licenseDate : '2025-02-15',
         wantToAddLicenseNumber : 'Yes',
         licenseNumber : 'ABC123',
         isBornInUK : 'No',
         yearObtainingUKResidency : '2024-08-12',
         employmentStatus : 'House Person',
         occupation : 'Housewife',
         hasChildren : 'Yes',
         numberOfChildren : 3,
         motorAccidentsOrClaimsIn5Years : 'Yes',
         motorAccidentsList : [
            {
               date: '2022-06-01',
               type: 'Accident',
               partyAtFault: 'Our Driver',
               wasAccidentSettled : 'Yes'
            },
            {
               date: '2024-10-12',
               type: 'Fire',
               partyAtFault: 'Other party',
               wasAccidentSettled : 'No'
            }
         ],
         motoringConvictionsIn5Years : 'Yes',
         motoringConvictionsList : [
            {
               code: 'PC10',
               date: '2021-04-15',
               points: '1',
               fines: 50,
               banLengthInMonths: 1,
               wasDriverBreathalysed: 'Yes',
               wasOffenceAccidentRelated: 'Yes',
            }
         ]
      }
   ],
   
   addAdditionalComments: 'No additional comments.',
   
   termsAgreement: 'Yes',
}